import { getYearMonthDay } from '@nx-smartmonkey/shared/helpers';
import { CalendarEventExternal } from '@schedule-x/calendar';

import { PlanFlat } from '../../../../domain/plan/PlanFlat';

export interface PlanCalendarEventProps extends CalendarEventExternal {
  plan: PlanFlat;
}

export class PlanCalendarEventMapper {
  static toCalendarEvent = (flatPlan: PlanFlat): PlanCalendarEventProps => {
    const date = getYearMonthDay({ date: flatPlan.execution_date });

    return {
      id: flatPlan.id,
      start: date,
      end: date,
      title: flatPlan.label,
      plan: flatPlan,
    };
  };
}
